'use client';

import { useEffect } from 'react';

export default function LandingPageInteractions() {
  useEffect(() => {
    // Animation on scroll
    const initScrollAnimation = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            }
          });
        },
        { threshold: 0.1 }
      );

      document.querySelectorAll('.animate-on-scroll').forEach((el) => {
        observer.observe(el);
      });
    };

    initScrollAnimation();
  }, []);

  return null;
}
